import { render, staticRenderFns } from "./CompanyItem.vue?vue&type=template&id=2f323107&"
import script from "./CompanyItem.vue?vue&type=script&lang=js&"
export * from "./CompanyItem.vue?vue&type=script&lang=js&"
import style0 from "./CompanyItem.vue?vue&type=style&index=0&id=2f323107&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports